








import { useEffect, useState } from "react";
import { DragDropContext } from "@hello-pangea/dnd";
import TaskColumn from "./TaskColumn";
import TaskDrawer from "./TaskDrawer";
import CreateTaskModal from "./CreateTaskModal";
import TaskCard from "./TaskCard";
import HoldReasonModal from "./HoldReasonModal";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { getDepartmentsApi, getEmployeesApi, createTeamApi } from "../../app/api";
import CreateTeamTaskDrawer from "../../pages/dashboard/components/teams/CreateTeamTaskDrawer";
import LateCompletionModal from "./LateCompletionModal";
import CreateTeamDrawer from "../../pages/dashboard/components/teams/CreateTeamDrawer";
import MonthlyTaskAccuracy from "../../pages/dashboard/components/MonthlyTaskAccuracy";
 
 
 
import {
  getMyTasksApi,
  getTeamTasksApi,
  updateTaskStatusApi,
  adminTaskAnalyticsApi,
} from "../../app/api";
const IMAGE_BASE_URL = "https://demouptask.visiontrek.io/";
 
const STATUSES = [
  { key: "TODO", label: "To Do" },
  { key: "IN_PROGRESS", label: "In Progress" },
  { key: "HOLD", label: "Hold" },
  { key: "REVIEW", label: "Review" },
  { key: "DONE", label: "Done" },
];
 
const emptyColumns = {
  TODO: [],
  IN_PROGRESS: [],
  REVIEW: [],
  HOLD: [],
  DONE: [],
};
 
const clone = (obj) => JSON.parse(JSON.stringify(obj));
 
const groupByStatus = (tasks) => {
  const cols = clone(emptyColumns);
  tasks.forEach((t) => {
    if (cols[t.status]) cols[t.status].push(t);
  });
  return cols;
};
 
 
 
export default function TasksBoard({ view }) {
 
  const [activeFilter, setActiveFilter] = useState("all");
 
 
  const [priorityFilter, setPriorityFilter] = useState(null);
const [completedFilter, setCompletedFilter] = useState(null);
const [filterOption, setFilterOption] = useState("DEFAULT");

const [recentTaskTimestamps, setRecentTaskTimestamps] = useState(() => {
  const stored = JSON.parse(localStorage.getItem("recentTaskTimestamps") || "{}");
  const now = Date.now();
  const cleaned = {};
  for (const [id, ts] of Object.entries(stored)) {
    if (now - ts < 7 * 24 * 60 * 60 * 1000) {
      cleaned[id] = ts;
    }
  }
  localStorage.setItem("recentTaskTimestamps", JSON.stringify(cleaned));
  return cleaned;
});

const markTaskAsRecent = (taskId) => {
  const now = Date.now();
  setRecentTaskTimestamps((prev) => {
    const updated = { ...prev, [taskId]: now };
    localStorage.setItem("recentTaskTimestamps", JSON.stringify(updated));
    return updated;
  });
};
 
 
  const [employeeSearch, setEmployeeSearch] = useState("");
 
const [departments, setDepartments] = useState([]);
const [employees, setEmployees] = useState([]);
 
 
const handleCreateTeam = async (e) => {
  e.preventDefault();
 
  const form = new FormData(e.target);
 
  const payload = {
    name: form.get("name"),
    department_id: Number(form.get("department_id")),
    members: Array.from(
      e.target.querySelectorAll("input[name='members']:checked")
    ).map((el) => Number(el.value)),
  };
 
  try {
    const res = await createTeamApi(payload);
 
    if (res.success) {
      setShowCreateTeam(false);
 
      // ✅ redirect to team page
      navigate("/dashboard/teams");
    }
  } catch (error) {
    console.error("Team creation failed:", error);
  }
};
 
 
  const [columns, setColumns] = useState(emptyColumns);
  const [selectedTask, setSelectedTask] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [holdModal, setHoldModal] = useState({ isOpen: false, task: null, destination: null, prevColumns: null });
  const [lateModal, setLateModal] = useState({ isOpen: false, task: null, destination: null, prevColumns: null });

  const navigate = useNavigate();
  const [showCreateTeam, setShowCreateTeam] = useState(false);
 
 
  const apiMap = {
    my: getMyTasksApi,
    all: adminTaskAnalyticsApi, // 👈 replace here
    team: getTeamTasksApi,
  };
 
 
  const refreshTasks = async (filters = {}) => {
    let res;
 
    const user = JSON.parse(localStorage.getItem("user"));
    const roleId = Number(user?.role_id);
    const isAdmin = roleId === 2;
 
    if (view === "all") {
 
      res = isAdmin
        ? await adminTaskAnalyticsApi(filters)
        : await getMyTasksApi();
    }
    else if (view === "my") {
      res = await getMyTasksApi();
    }
    else if (view === "team") {
      res = await getTeamTasksApi();
    }
 
    const tasks = Array.isArray(res)
      ? res
      : res?.data || [];
 
 
 
// const user = JSON.parse(localStorage.getItem("user"));
const loggedUserId = Number(user?.id);
 
 
let enrichedTasks = tasks.map((t) => {
  let assignedUsers = [];
 
  try {
    if (t.assignees) {
      assignedUsers = t.assignees;
    } else if (t.assigned_users) {
      assignedUsers =
        typeof t.assigned_users === "string"
          ? JSON.parse(t.assigned_users)
          : t.assigned_users;
    }
  } catch (e) {
    assignedUsers = [];
  }
 
  // ✅ ensure array
  if (!Array.isArray(assignedUsers)) {
    assignedUsers = [assignedUsers];
  }
 
  return {
    ...t,
    assignees: assignedUsers,
    is_locked:
      t.subtask_total > 0 &&
      t.subtask_completed !== t.subtask_total,
  };
});
 
if (view === "my") {
  enrichedTasks = enrichedTasks.filter((t) =>
    t.assignees.some((u) => Number(u.id) === loggedUserId)
  );
}
 
setColumns(groupByStatus(enrichedTasks));
 
    // setColumns(groupByStatus(tasks));
  };
 
 useEffect(() => {
    refreshTasks();
  }, [view]);  const onDragEnd = async ({ source, destination, draggableId }) => {
    if (!destination) return;
    if (source.droppableId === destination.droppableId) return;
 
    const prev = clone(columns);
    const from = source.droppableId;
    const to = destination.droppableId;
    const movedTask = columns[from][source.index];
 
    if (movedTask.is_locked) return;
 
    // 🔥 If moving to HOLD, show modal first
    if (to === "HOLD") {
      setHoldModal({
        isOpen: true,
        task: movedTask,
        destination,
        source,
        prevColumns: prev
      });
      return;
    }


// =====mpove done if late==

    if (to === "DONE" && movedTask.due_date) {
      const dueDate = new Date(movedTask.due_date);
      dueDate.setHours(0, 0, 0, 0);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (today > dueDate) {
        setLateModal({
          isOpen: true,
          task: movedTask,
          destination,
          source,
          prevColumns: prev
        });
        return;
      }
    }
 
    // Normal move
    proceedStatusUpdate(Number(draggableId), to, prev, source, destination);
  };
 
  // const proceedStatusUpdate = async (taskId, newStatus, prevCols, source, destination, reason = null) => {
const proceedStatusUpdate = async (
  taskId,
  newStatus,
  prevCols,
  source,
  destination,
  holdReason = null,
  completionReason = null
) => {

    const from = source.droppableId;
 
    setColumns((p) => {
      const next = clone(p);
      const moved = next[from][source.index];
      next[from].splice(source.index, 1);
      next[newStatus].unshift({ ...moved, status: newStatus });
      return next;
    });
 
    try {
      // await updateTaskStatusApi(taskId, { status: newStatus, reason });
      await updateTaskStatusApi(taskId, {
        status: newStatus,
        reason: holdReason,
        completion_reason: completionReason
      });
    } catch {
      setColumns(prevCols);
    }
  };
 
  const handleConfirmHold = (reason) => {
    const { task, destination, source, prevColumns } = holdModal;
    setHoldModal({ isOpen: false, task: null, destination: null, source: null, prevColumns: null });
    proceedStatusUpdate(task.id, "HOLD", prevColumns, source, destination, reason);
  };


  const handleConfirmLate = (reason) => {
    const { task, destination, source, prevColumns } = lateModal;
    setLateModal({ isOpen: false, task: null, destination: null, source: null, prevColumns: null });
    
    // We send completion_reason to the backend
    proceedStatusUpdate(task.id, "DONE", prevColumns, source, destination, null, reason);
  };
 
 const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
 
 
  useEffect(() => {
    loadDepartments();
    loadEmployees();
  }, []);
 
  const loadDepartments = async () => {
    const res = await getDepartmentsApi();
    if (res.success) setDepartments(res.data);
  };
 
  const loadEmployees = async () => {
    const res = await getEmployeesApi();
    if (res.success) setEmployees(res.data);
  };
 
 
 
 const [currentPage, setCurrentPage] = useState(1);
  const tasksPerPage = 8; // change how many cards per page
 
 
  // const allTasksFlat = Object.values(columns).flat();
  const allTasksFlat = Object.values(columns)
  .flat()
  .sort((a, b) => {
    const today = new Date().toISOString().split("T")[0];

    if (filterOption === "NEW_TASK") {
      const aCreated = new Date((a.created_at || "").replace(" ", "T")).getTime() || 0;
      const bCreated = new Date((b.created_at || "").replace(" ", "T")).getTime() || 0;
      return bCreated - aCreated;
    }

    if (filterOption === "DEADLINES") {
      const aDue = new Date((a.due_date || "2099-12-31").replace(" ", "T")).getTime();
      const bDue = new Date((b.due_date || "2099-12-31").replace(" ", "T")).getTime();
      return aDue - bDue; // nearest deadline first
    }

    if (filterOption === "NEW_SUBTASK") {
      const aRecent = recentTaskTimestamps[a.id] || 0;
      const bRecent = recentTaskTimestamps[b.id] || 0;
      return bRecent - aRecent;
    }

    // ✅ DEFAULT SMART PRIORITY (MATCH ATTENDANCE CHART)
    
    // 1. Today created first
    const aCreatedToday = a.created_at?.split(" ")[0] === today;
    const bCreatedToday = b.created_at?.split(" ")[0] === today;
    if (aCreatedToday !== bCreatedToday) return bCreatedToday - aCreatedToday;

    // 2. Recent activity (newly added subtasks etc)
    const aRecent = recentTaskTimestamps[a.id] || 0;
    const bRecent = recentTaskTimestamps[b.id] || 0;
    if (aRecent !== bRecent) return bRecent - aRecent;

    // 3. Fallback: Last activity date
    const getTime = (t) => {
      const dateStr = (
        t.calculated_last_activity ||
        t.updated_at ||
        t.created_at ||
        ""
      ).replace(" ", "T");
      return new Date(dateStr).getTime() || 0;
    };
    return getTime(b) - getTime(a);
  });
 
 
 
  const filteredTasks = allTasksFlat.filter((task) => {
 
 
    // ✅ COMPLETED FILTER
if (completedFilter !== null) {
  // if (completedFilter && !task.completed) return false;
  // if (!completedFilter && task.completed) return false;
 
  if (completedFilter === true && task.status !== "DONE") return false;
}
 
// ✅ PRIORITY FILTER
if (priorityFilter && task.priority !== priorityFilter) return false;
    // ✅ Employee filter
    if (employeeSearch) {
      const match = task.assignees?.some((emp) =>
        emp.name.toLowerCase().includes(employeeSearch.toLowerCase())
      );
      if (!match) return false;
    }
 
    const createdDate = task.created_at
      ? new Date(task.created_at.split(" ")[0])
      : null;
 
    // ✅ Convert filter dates
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;
 
    // ✅ RANGE FILTER
    if (start && createdDate && createdDate < start) return false;
    if (end && createdDate && createdDate > end) return false;
 
    return true;
  });
 
 
 
  const indexOfLastTask = currentPage * tasksPerPage;
  const indexOfFirstTask = indexOfLastTask - tasksPerPage;
 
  const currentTasks = filteredTasks.slice(
    indexOfFirstTask,
    indexOfLastTask
  );
 
  const totalPages = Math.ceil(filteredTasks.length / tasksPerPage);
 
 
 
  useEffect(() => {
    setCurrentPage(1);
  }, [startDate, endDate, columns]);
 
 
 
 
 
  const location = useLocation();
 
  useEffect(() => {
    if (location.state?.openCreate) {
      setShowCreateModal(true);
    }
  }, [location.state]);
 
 
  return (
    <div className={`bg-gradient-to-br from-[#fdfbff] via-[#eef2ff] to-[#ecfeff] min-h-screen rounded-lg ${view === "monthly" ? "p-0 mt-0" : "p-6 md:mt-20"}`}>
      <div className="max-w-[1600px] mx-auto">
 
        {/* ===== PAGE HEADER ===== */}
        {view !== "monthly" && (
          <div className="
            bg-gradient-to-br
            from-[#2d1c6a]
            via-[#24155a]
            to-[#12082f]
            text-white
          rounded-[16px] p-6 text-white mb-6 shadow-xl">
            <div className="flex flex-col md:flex-row justify-between items-start gap-3">
              <div>
                <h1 className="text-3xl font-bold capitalize whitespace-nowrap ">
                  {view} Tasks
                </h1>
                <p className="text-sm opacity-90 mt-1">
                  Create, drag and manage tasks like Trello
                </p>
              </div>

              {view === "team" ? (
                <button
                  onClick={() => setShowCreateTeam(true)}
                  className="bg-white/20 px-2 py-1 md:px-6 md:py-2 whitespace-nowrap rounded-md hover:bg-white/30 transition shadow-lg mt-1 md:mt-1"
                >
                  + Create Team
                </button>
              ) : (
                <button
                  onClick={() => setShowCreateModal(true)}
                  className="bg-white/20 px-2 py-1 md:px-6 md:py-2 whitespace-nowrap rounded-md hover:bg-white/30 transition shadow-lg mt-1 md:mt-1"
                >
                  + Create Task
                </button>
              )}
            </div>
          </div>
        )}
 
 
  {/* ===== FILTER BUTTONS (ADD HERE) ===== */}
 
 
 
  {view === "all" && (
  <div className="mt-6 bg-white p-4 rounded-xl shadow-md">
 
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
 
      {/* ===== LEFT SIDE FILTER BUTTONS ===== */}
      <div className="flex  flex-row md:gap-2 gap-1 flex-wrap">
 
 
<button
 
 
  onClick={() => {
    setActiveFilter("all");
    setCompletedFilter(null);
    setPriorityFilter(null);
  }}
  className={`px-4 py-2 rounded-lg text-sm font-medium transition
    ${activeFilter === "all"
      ? "bg-indigo-600 text-white shadow"
      : "bg-blue-100 hover:bg-gray-200 text-gray-700"}
  `}
>
  All
</button>
 
 
 
 
<button
 
  onClick={() => {
    setActiveFilter("completed");
    setCompletedFilter(true);
    setPriorityFilter(null);
  }}
  className={`px-3 py-2 rounded-lg text-sm font-medium transition
    ${activeFilter === "completed"
      ? "bg-green-600 text-white"
      : "bg-green-100 hover:bg-green-200 text-green-700"}
  `}
>
  Completed
</button>
 
       
 
<button
 onClick={() => {
  setActiveFilter("high");
  setCompletedFilter(false);
  setPriorityFilter("HIGH");
}}
  className={`px-3 py-2 rounded-lg text-sm font-medium transition
    ${activeFilter === "high"
      ? "bg-red-600 text-white"
      : "bg-red-100 hover:bg-red-200 text-red-700"}
  `}
>
  High Priority
</button>

<select
  value={filterOption}
  onChange={(e) => setFilterOption(e.target.value)}
  className="
    px-3 py-2 text-sm rounded-lg
    bg-gray-100 text-gray-700
    border border-gray-300
    shadow-sm focus:outline-none
    cursor-pointer transition
    hover:bg-gray-200
  "
>
  <option value="DEFAULT">Default</option>
  <option value="NEW_TASK">New Task</option>
  <option value="NEW_SUBTASK">Newly added subtask</option>
  <option value="DEADLINES">Deadlines nearer</option>
</select>
 
      </div>
 
      {/* ===== RIGHT SIDE DATE FILTER ===== */}
      <div className="flex flex-wrap gap-3 items-end">
 
 
 
 
      <div className="flex flex-col">
  <label className="text-xs text-gray-500 mb-1">
    Employee Name
  </label>
 
  <input
    type="text"
    placeholder="Search employee..."
    value={employeeSearch}
    onChange={(e) => setEmployeeSearch(e.target.value)}
    className="shadow-lg bg-gray-200 md:px-1.5 px-3 py-2 rounded-sm text-sm text-[black] outline-none"
  />
</div>
 
 
 
<div className="flex md:flex-row gap-2 ">
        {/* Start Date */}
        <div className="flex flex-col">
          <label className="text-xs text-gray-500 mb-1">
            From Date
          </label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className=" shadow-lg bg-gray-200 md:px-3 px-1 py-2 rounded-sm text-sm  outline-none"
          />
        </div>
 
        {/* End Date */}
        <div className="flex flex-col">
          <label className="text-xs text-gray-500 mb-1">
            To Date
          </label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="shadow-lg bg-gray-200 md:px-3 px-1  py-2 rounded-sm text-sm  outline-none"
          />
        </div>
        </div>
 
        {/* Apply */}
        <button
          onClick={() => refreshTasks()}
          className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md text-sm shadow-lg transition"
        >
          Apply
        </button>
 
        {/* Clear */}
        <button
   
          onClick={() => {
            setStartDate("");
            setEndDate("");
            setEmployeeSearch("");   // ✅ ADD THIS
            setCurrentPage(1);       // ✅ RESET PAGE
            setActiveFilter("all"); // ✅ ADD THIS
            refreshTasks();
          }}
 
 
          className="shadow-lg bg-gray-200 hover:bg-gray-300 text-gray-700 px-4 py-2 rounded-sm text-sm transition"
        >
          Clear
        </button>
 
      </div>
</div>
</div>
)}
 
 
{view === "monthly" ? (
  <div className="md:mt-20 md:p-6">
  <MonthlyTaskAccuracy />
  </div>
) : view === "all" ? (
  /* ===== ALL TASKS GRID VIEW ===== */
  <div className=" bg-[#1b153f] p-8 md:mt-4 mt-2 rounded-[20px]">
 
 
 
<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
 
  {currentTasks.length === 0 ? (
    <div className="col-span-full flex flex-col items-center justify-center py-16 text-center">
     
      <p className="text-gray-400 text-lg font-medium">
        No tasks available
      </p>
 
      <p className="text-gray-500 text-sm mt-2">
        Try changing filters or clearing search
      </p>
 
    </div>
  ) : (
    currentTasks.map((task, index) => (
      <TaskCard
        key={task.id}
        task={task}
        index={index}
        onClick={() => setSelectedTask(task)}
        draggable={false}
      />
    ))
  )}
 
</div>
 
 
 
 
   {/* ===== PAGINATION BUTTONS ===== */}
   {/* {totalPages > 1 && ( */}
    {currentTasks.length > 0 && totalPages > 1 && (
      <div className="flex justify-center items-center mt-8 gap-4 flex-wrap">
        <button
          onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
          disabled={currentPage === 1}
          className="px-4 py-2 rounded-md text-sm transition shadow bg-gray-200 hover:bg-gray-300 text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Prev
        </button>
        <span className="text-sm font-medium text-white/90">
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
          disabled={currentPage === totalPages}
          className="px-4 py-2 rounded-md text-sm transition shadow bg-gray-200 hover:bg-gray-300 text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Next
        </button>
      </div>
    )}
 
  </div>
 
 
) : (
 
  /* ===== NORMAL TRELLO BOARD ===== */
  <DragDropContext onDragEnd={onDragEnd}>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
      {STATUSES.map((col) => (
        <TaskColumn
          key={col.key}
          title={col.label}
          status={col.key}
          tasks={columns[col.key]}
          onTaskClick={setSelectedTask}
 
          isMyView={view === "my"}   // 👈 ADD THIS
        />
      ))}
    </div>
 
  </DragDropContext>
)}
 
 
{/* ===== INSTRUCTIONS ===== */}
{view !== "monthly" && (
  <div className="mt-6 bg-white rounded-xl p-5 shadow-md">
    <h3 className="text-lg font-semibold text-gray-800 mb-2">
      How to use this board
    </h3>
  
    <ul className="text-sm text-gray-600 space-y-2 list-disc pl-5">
      <li>Drag tasks from <b>To Do</b> → <b>In Progress</b> to start working.</li>
      <li>If work is paused, move task to <b>Hold</b>.</li>
      <li>From <b>Hold</b>, you can move tasks to <b>In Progress </b>then <b>Review </b>.</li>
      <li>After completion, move tasks to <b>Done</b>.</li>
      <li>Locked tasks (🔒) cannot be moved until subtasks are completed.</li>
    </ul>
  </div>
)}
 
 
        {/* ===== DRAWER ===== */}
        <TaskDrawer
          open={!!selectedTask}
          task={selectedTask}
          onClose={() => setSelectedTask(null)}
          onSubtaskUpdate={markTaskAsRecent}
          onStatusChange={(updated) => {
            setColumns((prev) => {
              const next = clone(prev);
              Object.keys(next).forEach(
                (k) => (next[k] = next[k].filter((t) => t.id !== updated.id))
              );
              next[updated.status].unshift(updated);
              return next;
            });
            setSelectedTask(updated);
          }}
        />
 
        {/* ===== CREATE TASK MODAL ===== */}
        <CreateTaskModal
          open={showCreateModal}
          onClose={() => setShowCreateModal(false)}
          onCreated={refreshTasks}
        />
 
 
<CreateTeamDrawer
  open={showCreateTeam}
  onClose={() => setShowCreateTeam(false)}
  onSubmit={handleCreateTeam}
  departments={departments}
  employees={employees}
/>
 
<HoldReasonModal
  isOpen={holdModal.isOpen}
  onClose={() => setHoldModal({ isOpen: false, task: null, destination: null, source: null, prevColumns: null })}
  onConfirm={handleConfirmHold}
  taskTitle={holdModal.task?.title}
/>


<LateCompletionModal
  isOpen={lateModal.isOpen}
  onClose={() => setLateModal({ isOpen: false, task: null, destination: null, source: null, prevColumns: null })}
  onConfirm={handleConfirmLate}
  taskTitle={lateModal.task?.title}
/>

      </div>
    </div>
 
   
  );
}








// import { useEffect, useState } from "react";
// import { DragDropContext } from "@hello-pangea/dnd";
// import TaskColumn from "./TaskColumn";
// import TaskDrawer from "./TaskDrawer";
// import CreateTaskModal from "./CreateTaskModal";
// import TaskCard from "./TaskCard";
// import HoldReasonModal from "./HoldReasonModal";
// import LateCompletionModal from "./LateCompletionModal";
// import { useNavigate } from "react-router-dom";
// import { useLocation } from "react-router-dom";
// import { getDepartmentsApi, getEmployeesApi, createTeamApi } from "../../app/api";
// import CreateTeamTaskDrawer from "../../pages/dashboard/components/teams/CreateTeamTaskDrawer";
 
// import CreateTeamDrawer from "../../pages/dashboard/components/teams/CreateTeamDrawer";
 
 
 
// import {
//   getMyTasksApi,
//   getTeamTasksApi,
//   updateTaskStatusApi,
//   adminTaskAnalyticsApi,
// } from "../../app/api";
// const IMAGE_BASE_URL = "https://uptask.visiontrek.io";
 
// const STATUSES = [
//   { key: "TODO", label: "To Do" },
//   { key: "IN_PROGRESS", label: "In Progress" },
//   { key: "HOLD", label: "Hold" },
//   { key: "REVIEW", label: "Review" },
//   { key: "DONE", label: "Done" },
// ];
 
// const emptyColumns = {
//   TODO: [],
//   IN_PROGRESS: [],
//   REVIEW: [],
//   HOLD: [],
//   DONE: [],
// };
 
// const clone = (obj) => JSON.parse(JSON.stringify(obj));
 
// const groupByStatus = (tasks) => {
//   const cols = clone(emptyColumns);
//   tasks.forEach((t) => {
//     if (cols[t.status]) cols[t.status].push(t);
//   });
//   return cols;
// };
 
 
 
// export default function TasksBoard({ view }) {
 
//   const [activeFilter, setActiveFilter] = useState("all");
 
 
//   const [priorityFilter, setPriorityFilter] = useState(null);
// const [completedFilter, setCompletedFilter] = useState(null);
// const [filterOption, setFilterOption] = useState("DEFAULT");

// const [recentTaskTimestamps, setRecentTaskTimestamps] = useState(() => {
//   const stored = JSON.parse(localStorage.getItem("recentTaskTimestamps") || "{}");
//   const now = Date.now();
//   const cleaned = {};
//   for (const [id, ts] of Object.entries(stored)) {
//     if (now - ts < 7 * 24 * 60 * 60 * 1000) {
//       cleaned[id] = ts;
//     }
//   }
//   localStorage.setItem("recentTaskTimestamps", JSON.stringify(cleaned));
//   return cleaned;
// });

// const markTaskAsRecent = (taskId) => {
//   const now = Date.now();
//   setRecentTaskTimestamps((prev) => {
//     const updated = { ...prev, [taskId]: now };
//     localStorage.setItem("recentTaskTimestamps", JSON.stringify(updated));
//     return updated;
//   });
// };
 
 
//   const [employeeSearch, setEmployeeSearch] = useState("");
 
// const [departments, setDepartments] = useState([]);
// const [employees, setEmployees] = useState([]);
 
 
// const handleCreateTeam = async (e) => {
//   e.preventDefault();
 
//   const form = new FormData(e.target);
 
//   const payload = {
//     name: form.get("name"),
//     department_id: Number(form.get("department_id")),
//     members: Array.from(
//       e.target.querySelectorAll("input[name='members']:checked")
//     ).map((el) => Number(el.value)),
//   };
 
//   try {
//     const res = await createTeamApi(payload);
 
//     if (res.success) {
//       setShowCreateTeam(false);
 
//       // ✅ redirect to team page
//       navigate("/dashboard/teams");
//     }
//   } catch (error) {
//     console.error("Team creation failed:", error);
//   }
// };
 
 
//   const [columns, setColumns] = useState(emptyColumns);
//   const [selectedTask, setSelectedTask] = useState(null);
//   const [showCreateModal, setShowCreateModal] = useState(false);
//   const [holdModal, setHoldModal] = useState({ isOpen: false, task: null, destination: null, prevColumns: null });
  // const [lateModal, setLateModal] = useState({ isOpen: false, task: null, destination: null, prevColumns: null });
//   const navigate = useNavigate();
//   const [showCreateTeam, setShowCreateTeam] = useState(false);
 
 
//   const apiMap = {
//     my: getMyTasksApi,
//     all: adminTaskAnalyticsApi, // 👈 replace here
//     team: getTeamTasksApi,
//   };
 
 
//   const refreshTasks = async (filters = {}) => {
//     let res;
 
//     const user = JSON.parse(localStorage.getItem("user"));
//     const roleId = Number(user?.role_id);
//     const isAdmin = roleId === 2;
 
//     if (view === "all") {
 
//       res = isAdmin
//         ? await adminTaskAnalyticsApi(filters)
//         : await getMyTasksApi();
//     }
//     else if (view === "my") {
//       res = await getMyTasksApi();
//     }
//     else if (view === "team") {
//       res = await getTeamTasksApi();
//     }
 
//     const tasks = Array.isArray(res)
//       ? res
//       : res?.data || [];
 
 
 
// // const user = JSON.parse(localStorage.getItem("user"));
// const loggedUserId = Number(user?.id);
 
 
// let enrichedTasks = tasks.map((t) => {
//   let assignedUsers = [];
 
//   try {
//     if (t.assignees) {
//       assignedUsers = t.assignees;
//     } else if (t.assigned_users) {
//       assignedUsers =
//         typeof t.assigned_users === "string"
//           ? JSON.parse(t.assigned_users)
//           : t.assigned_users;
//     }
//   } catch (e) {
//     assignedUsers = [];
//   }
 
//   // ✅ ensure array
//   if (!Array.isArray(assignedUsers)) {
//     assignedUsers = [assignedUsers];
//   }
 
//   return {
//     ...t,
//     assignees: assignedUsers,
//     is_locked:
//       t.subtask_total > 0 &&
//       t.subtask_completed !== t.subtask_total,
//   };
// });
 
// if (view === "my") {
//   enrichedTasks = enrichedTasks.filter((t) =>
//     t.assignees.some((u) => Number(u.id) === loggedUserId)
//   );
// }
 
// setColumns(groupByStatus(enrichedTasks));
 
//     // setColumns(groupByStatus(tasks));
//   };
 
//  useEffect(() => {
//     refreshTasks();
//   }, [view]);  const onDragEnd = async ({ source, destination, draggableId }) => {
//     if (!destination) return;
//     if (source.droppableId === destination.droppableId) return;
 
//     const prev = clone(columns);
//     const from = source.droppableId;
//     const to = destination.droppableId;
//     const movedTask = columns[from][source.index];
 
//     if (movedTask.is_locked) return;
 
//     // 🔥 If moving to HOLD, show modal first
//     if (to === "HOLD") {
//       setHoldModal({
//         isOpen: true,
//         task: movedTask,
//         destination,
//         source,
//         prevColumns: prev
//       });
//       return;
//     }
 
//     // 🔥 If moving to DONE and it's late, show modal
    // if (to === "DONE" && movedTask.due_date) {
    //   const dueDate = new Date(movedTask.due_date);
    //   dueDate.setHours(0, 0, 0, 0);
    //   const today = new Date();
    //   today.setHours(0, 0, 0, 0);

    //   if (today > dueDate) {
    //     setLateModal({
    //       isOpen: true,
    //       task: movedTask,
    //       destination,
    //       source,
    //       prevColumns: prev
    //     });
    //     return;
    //   }
    // }

//     // Normal move
//     proceedStatusUpdate(Number(draggableId), to, prev, source, destination);
//   };
 
//   const proceedStatusUpdate = async (taskId, newStatus, prevCols, source, destination, holdReason = null, completionReason = null) => {
//     const from = source.droppableId;
 
//     setColumns((p) => {
//       const next = clone(p);
//       const moved = next[from][source.index];
//       next[from].splice(source.index, 1);
//       next[newStatus].unshift({ ...moved, status: newStatus });
//       return next;
//     });
 
//     try {
//       await updateTaskStatusApi(taskId, { 
//         status: newStatus, 
//         reason: holdReason,
//         completion_reason: completionReason 
//       });
//     } catch {
//       setColumns(prevCols);
//     }
//   };
 
//   const handleConfirmHold = (reason) => {
//     const { task, destination, source, prevColumns } = holdModal;
//     setHoldModal({ isOpen: false, task: null, destination: null, source: null, prevColumns: null });
//     proceedStatusUpdate(task.id, "HOLD", prevColumns, source, destination, reason);
//   };

//   const handleConfirmLate = (reason) => {
//     const { task, destination, source, prevColumns } = lateModal;
//     setLateModal({ isOpen: false, task: null, destination: null, source: null, prevColumns: null });
    
//     // We send completion_reason to the backend
//     proceedStatusUpdate(task.id, "DONE", prevColumns, source, destination, null, reason);
//   };
 
//  const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
 
 
//   useEffect(() => {
//     loadDepartments();
//     loadEmployees();
//   }, []);
 
//   const loadDepartments = async () => {
//     const res = await getDepartmentsApi();
//     if (res.success) setDepartments(res.data);
//   };
 
//   const loadEmployees = async () => {
//     const res = await getEmployeesApi();
//     if (res.success) setEmployees(res.data);
//   };
 
 
 
//  const [currentPage, setCurrentPage] = useState(1);
//   const tasksPerPage = 8; // change how many cards per page
 
 
//   // const allTasksFlat = Object.values(columns).flat();
//   const allTasksFlat = Object.values(columns)
//   .flat()
//   .sort((a, b) => {
//     if (filterOption === "NEW_TASK") {
//       const aCreated = new Date((a.created_at || "").replace(" ", "T")).getTime() || 0;
//       const bCreated = new Date((b.created_at || "").replace(" ", "T")).getTime() || 0;
//       return bCreated - aCreated;
//     }

//     if (filterOption === "DEADLINES") {
//       const aDue = new Date((a.due_date || "2099-12-31").replace(" ", "T")).getTime();
//       const bDue = new Date((b.due_date || "2099-12-31").replace(" ", "T")).getTime();
//       return aDue - bDue; // nearest deadline first
//     }

//     if (filterOption === "NEW_SUBTASK") {
//       const aRecent = recentTaskTimestamps[a.id] || 0;
//       const bRecent = recentTaskTimestamps[b.id] || 0;
//       return bRecent - aRecent;
//     }

//     // Default: Created date descending
//     return new Date(b.created_at) - new Date(a.created_at);
//   });
 
 
 
//   const filteredTasks = allTasksFlat.filter((task) => {
 
 
//     // ✅ COMPLETED FILTER
// if (completedFilter !== null) {
//   // if (completedFilter && !task.completed) return false;
//   // if (!completedFilter && task.completed) return false;
 
//   if (completedFilter === true && task.status !== "DONE") return false;
// }
 
// // ✅ PRIORITY FILTER
// if (priorityFilter && task.priority !== priorityFilter) return false;
//     // ✅ Employee filter
//     if (employeeSearch) {
//       const match = task.assignees?.some((emp) =>
//         emp.name.toLowerCase().includes(employeeSearch.toLowerCase())
//       );
//       if (!match) return false;
//     }
 
//     const createdDate = task.created_at
//       ? new Date(task.created_at.split(" ")[0])
//       : null;
 
//     // ✅ Convert filter dates
//     const start = startDate ? new Date(startDate) : null;
//     const end = endDate ? new Date(endDate) : null;
 
//     // ✅ RANGE FILTER
//     if (start && createdDate && createdDate < start) return false;
//     if (end && createdDate && createdDate > end) return false;
 
//     return true;
//   });
 
 
 
//   const indexOfLastTask = currentPage * tasksPerPage;
//   const indexOfFirstTask = indexOfLastTask - tasksPerPage;
 
//   const currentTasks = filteredTasks.slice(
//     indexOfFirstTask,
//     indexOfLastTask
//   );
 
//   const totalPages = Math.ceil(filteredTasks.length / tasksPerPage);
 
 
 
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [startDate, endDate, columns]);
 
 
 
 
 
//   const location = useLocation();
 
//   useEffect(() => {
//     if (location.state?.openCreate) {
//       setShowCreateModal(true);
//     }
//   }, [location.state]);
 
 
//   return (
//     <div className="bg-gradient-to-br from-[#fdfbff] via-[#eef2ff] to-[#ecfeff] min-h-screen p-6 md:mt-20 rounded-lg min-h-screen">
//       <div className="max-w-[1600px] mx-auto">
 
//         {/* ===== PAGE HEADER ===== */}
//         <div className="
//           bg-gradient-to-br
//           from-[#2d1c6a]
//           via-[#24155a]
//           to-[#12082f]
//           text-white
//         rounded-[16px] p-6 text-white mb-6 shadow-xl">
//           <div className="flex flex-col md:flex-row justify-between items-start gap-3">
//             <div>
//               <h1 className="text-3xl font-bold capitalize whitespace-nowrap ">
//                 {view} Tasks
//               </h1>
//               <p className="text-sm opacity-90 mt-1">
//                 Create, drag and manage tasks like Trello
//               </p>
//             </div>
 
         
// {view === "team" ? (
//   <button
//     onClick={() => setShowCreateTeam(true)}
//     className="bg-white/20 px-2 py-1 md:px-6 md:py-2 whitespace-nowrap rounded-md hover:bg-white/30 transition shadow-lg mt-1 md:mt-1"
//   >
//     + Create Team
//   </button>
// ) : (
//   <button
//     onClick={() => setShowCreateModal(true)}
//     className="bg-white/20 px-2 py-1 md:px-6 md:py-2 whitespace-nowrap rounded-md hover:bg-white/30 transition shadow-lg mt-1 md:mt-1"
//   >
//     + Create Task
//   </button>
// )}
//           </div>
//         </div>
 
 
//   {/* ===== FILTER BUTTONS (ADD HERE) ===== */}
 
 
 
//   {view === "all" && (
//   <div className="mt-6 bg-white p-4 rounded-xl shadow-md">
 
//     <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
 
//       {/* ===== LEFT SIDE FILTER BUTTONS ===== */}
//       <div className="flex  flex-row md:gap-2 gap-1 flex-wrap">
 
 
// <button
 
 
//   onClick={() => {
//     setActiveFilter("all");
//     setCompletedFilter(null);
//     setPriorityFilter(null);
//   }}
//   className={`px-4 py-2 rounded-lg text-sm font-medium transition
//     ${activeFilter === "all"
//       ? "bg-indigo-600 text-white shadow"
//       : "bg-blue-100 hover:bg-gray-200 text-gray-700"}
//   `}
// >
//   All
// </button>
 
 
 
 
// <button
 
//   onClick={() => {
//     setActiveFilter("completed");
//     setCompletedFilter(true);
//     setPriorityFilter(null);
//   }}
//   className={`px-3 py-2 rounded-lg text-sm font-medium transition
//     ${activeFilter === "completed"
//       ? "bg-green-600 text-white"
//       : "bg-green-100 hover:bg-green-200 text-green-700"}
//   `}
// >
//   Completed
// </button>
 
       
 
// <button
//  onClick={() => {
//   setActiveFilter("high");
//   setCompletedFilter(false);
//   setPriorityFilter("HIGH");
// }}
//   className={`px-3 py-2 rounded-lg text-sm font-medium transition
//     ${activeFilter === "high"
//       ? "bg-red-600 text-white"
//       : "bg-red-100 hover:bg-red-200 text-red-700"}
//   `}
// >
//   High Priority
// </button>

// <select
//   value={filterOption}
//   onChange={(e) => setFilterOption(e.target.value)}
//   className="
//     px-3 py-2 text-sm rounded-lg
//     bg-gray-100 text-gray-700
//     border border-gray-300
//     shadow-sm focus:outline-none
//     cursor-pointer transition
//     hover:bg-gray-200
//   "
// >
//   <option value="DEFAULT">Default</option>
//   <option value="NEW_TASK">New Task</option>
//   <option value="NEW_SUBTASK">Newly added subtask</option>
//   <option value="DEADLINES">Deadlines nearer</option>
// </select>
 
//       </div>
 
//       {/* ===== RIGHT SIDE DATE FILTER ===== */}
//       <div className="flex flex-wrap gap-3 items-end">
 
 
 
 
//       <div className="flex flex-col">
//   <label className="text-xs text-gray-500 mb-1">
//     Employee Name
//   </label>
 
//   <input
//     type="text"
//     placeholder="Search employee..."
//     value={employeeSearch}
//     onChange={(e) => setEmployeeSearch(e.target.value)}
//     className="shadow-lg bg-gray-200 md:px-1.5 px-3 py-2 rounded-sm text-sm text-[black] outline-none"
//   />
// </div>
 
 
 
// <div className="flex md:flex-row gap-2 ">
//         {/* Start Date */}
//         <div className="flex flex-col">
//           <label className="text-xs text-gray-500 mb-1">
//             From Date
//           </label>
//           <input
//             type="date"
//             value={startDate}
//             onChange={(e) => setStartDate(e.target.value)}
//             className=" shadow-lg bg-gray-200 md:px-3 px-1 py-2 rounded-sm text-sm  outline-none"
//           />
//         </div>
 
//         {/* End Date */}
//         <div className="flex flex-col">
//           <label className="text-xs text-gray-500 mb-1">
//             To Date
//           </label>
//           <input
//             type="date"
//             value={endDate}
//             onChange={(e) => setEndDate(e.target.value)}
//             className="shadow-lg bg-gray-200 md:px-3 px-1  py-2 rounded-sm text-sm  outline-none"
//           />
//         </div>
//         </div>
 
//         {/* Apply */}
//         <button
//           onClick={() => refreshTasks()}
//           className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md text-sm shadow-lg transition"
//         >
//           Apply
//         </button>
 
//         {/* Clear */}
//         <button
   
//           onClick={() => {
//             setStartDate("");
//             setEndDate("");
//             setEmployeeSearch("");   // ✅ ADD THIS
//             setCurrentPage(1);       // ✅ RESET PAGE
//             setActiveFilter("all"); // ✅ ADD THIS
//             refreshTasks();
//           }}
 
 
//           className="shadow-lg bg-gray-200 hover:bg-gray-300 text-gray-700 px-4 py-2 rounded-sm text-sm transition"
//         >
//           Clear
//         </button>
 
//       </div>
// </div>
// </div>
// )}
 
 
// {view === "all" ? (
//   /* ===== ALL TASKS GRID VIEW ===== */
//   <div className=" bg-[#1b153f] p-8 md:mt-4 mt-2 rounded-[20px]">
 
 
 
// <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
 
//   {currentTasks.length === 0 ? (
//     <div className="col-span-full flex flex-col items-center justify-center py-16 text-center">
     
//       <p className="text-gray-400 text-lg font-medium">
//         No tasks available
//       </p>
 
//       <p className="text-gray-500 text-sm mt-2">
//         Try changing filters or clearing search
//       </p>
 
//     </div>
//   ) : (
//     currentTasks.map((task, index) => (
//       <TaskCard
//         key={task.id}
//         task={task}
//         index={index}
//         onClick={() => setSelectedTask(task)}
//         draggable={false}
//       />
//     ))
//   )}
 
// </div>
 
 
 
 
//    {/* ===== PAGINATION BUTTONS ===== */}
//    {/* {totalPages > 1 && ( */}
//     {currentTasks.length > 0 && totalPages > 1 && (
//       <div className="flex justify-center items-center mt-8 gap-4 flex-wrap">
//         <button
//           onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
//           disabled={currentPage === 1}
//           className="px-4 py-2 rounded-md text-sm transition shadow bg-gray-200 hover:bg-gray-300 text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
//         >
//           Prev
//         </button>
//         <span className="text-sm font-medium text-white/90">
//           Page {currentPage} of {totalPages}
//         </span>
//         <button
//           onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
//           disabled={currentPage === totalPages}
//           className="px-4 py-2 rounded-md text-sm transition shadow bg-gray-200 hover:bg-gray-300 text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
//         >
//           Next
//         </button>
//       </div>
//     )}
 
//   </div>
 
 
// ) : (
 
//   /* ===== NORMAL TRELLO BOARD ===== */
//   <DragDropContext onDragEnd={onDragEnd}>
//     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
//       {STATUSES.map((col) => (
//         <TaskColumn
//           key={col.key}
//           title={col.label}
//           status={col.key}
//           tasks={columns[col.key]}
//           onTaskClick={setSelectedTask}
 
//           isMyView={view === "my"}   // 👈 ADD THIS
//         />
//       ))}
//     </div>
 
//   </DragDropContext>
// )}
 
 
// {/* ===== INSTRUCTIONS ===== */}
// <div className="mt-6 bg-white rounded-xl p-5 shadow-md">
//   <h3 className="text-lg font-semibold text-gray-800 mb-2">
//     How to use this board
//   </h3>
 
//   <ul className="text-sm text-gray-600 space-y-2 list-disc pl-5">
//     <li>Drag tasks from <b>To Do</b> → <b>In Progress</b> to start working.</li>
//     <li>If work is paused, move task to <b>Hold</b>.</li>
//     <li>From <b>Hold</b>, you can move tasks to <b>In Progress </b>then <b>Review </b>.</li>
//     <li>After completion, move tasks to <b>Done</b>.</li>
//     <li>Locked tasks (🔒) cannot be moved until subtasks are completed.</li>
//   </ul>
// </div>
 
 
//         {/* ===== DRAWER ===== */}
//         <TaskDrawer
//           open={!!selectedTask}
//           task={selectedTask}
//           onClose={() => setSelectedTask(null)}
//           onStatusChange={(updated) => {
//             setColumns((prev) => {
//               const next = clone(prev);
//               Object.keys(next).forEach(
//                 (k) => (next[k] = next[k].filter((t) => t.id !== updated.id))
//               );
//               next[updated.status].unshift(updated);
//               return next;
//             });
//             setSelectedTask(updated);
//           }}
//         />
 
//         {/* ===== CREATE TASK MODAL ===== */}
//         <CreateTaskModal
//           open={showCreateModal}
//           onClose={() => setShowCreateModal(false)}
//           onCreated={refreshTasks}
//         />
 
 
// <CreateTeamDrawer
//   open={showCreateTeam}
//   onClose={() => setShowCreateTeam(false)}
//   onSubmit={handleCreateTeam}
//   departments={departments}
//   employees={employees}
// />
 
// <HoldReasonModal
//   isOpen={holdModal.isOpen}
//   onClose={() => setHoldModal({ isOpen: false, task: null, destination: null, source: null, prevColumns: null })}
//   onConfirm={handleConfirmHold}
//   taskTitle={holdModal.task?.title}
// />

{/* <LateCompletionModal
  isOpen={lateModal.isOpen}
  onClose={() => setLateModal({ isOpen: false, task: null, destination: null, source: null, prevColumns: null })}
  onConfirm={handleConfirmLate}
  taskTitle={lateModal.task?.title}
/> */}
//       </div>
//     </div>
 
   
//   );
// }




